import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useEntity, MissingAnnotationEmptyState } from '@backstage/plugin-catalog-react';
import { getOneOfEntityAnnotations } from '@aws/aws-core-plugin-for-backstage-common';
import { AWS_CODEPIPELINE_ARN_ANNOTATION, AWS_CODEPIPELINE_TAGS_ANNOTATION, AWS_CODEPIPELINE_ARN_ANNOTATION_LEGACY } from '@aws/aws-codepipeline-plugin-for-backstage-common';
import { CodePipelineExecutions } from './CodePipelineExecutions/CodePipelineExecutions.esm.js';

const isAwsCodePipelineAvailable = (entity) => getOneOfEntityAnnotations(entity, [
  AWS_CODEPIPELINE_ARN_ANNOTATION,
  AWS_CODEPIPELINE_TAGS_ANNOTATION,
  AWS_CODEPIPELINE_ARN_ANNOTATION_LEGACY
]) !== void 0;
const Router = () => {
  const { entity } = useEntity();
  if (!isAwsCodePipelineAvailable(entity)) {
    return /* @__PURE__ */ React.createElement(
      MissingAnnotationEmptyState,
      {
        annotation: [
          AWS_CODEPIPELINE_ARN_ANNOTATION,
          AWS_CODEPIPELINE_TAGS_ANNOTATION
        ]
      }
    );
  }
  return /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { path: "/", element: /* @__PURE__ */ React.createElement(CodePipelineExecutions, { entity }) }));
};

export { Router, isAwsCodePipelineAvailable };
//# sourceMappingURL=Router.esm.js.map
